'use strict';

const stopInfoUtils = require('../../utils/flight_summary/stop_info.utils');
const stopInfoMap = require('../../utils/flight_summary/stop_info.map');
const isMobile = Odigeo.SessionScope.flow === 'mobile';
const stopDetailsFactory = isMobile
    ? require('components/flights/stop_details/js/main.mobile')
    : require('components/flights/stop_details/js/main.desktop');
const StopInfoHubView = require('./stop_info_hub.view');
const MODULE = 'flightsummary';
const TRAIN = 'TRN';

module.exports = Backbone.View.extend({

    initialize(options) {
        this.options = options;
        this.keys = Odigeo._.clone(options.keys);
        this.previousSection = options.previousSection;
        this.section = options.section;
        this.isChangeOfCarrierOnly = false;
        this.stopType = this.getStopType();

        Odigeo.Templates.getGenericTemplates([MODULE])
            .then(({flightsummary}) => {
                const {stopInfo} = flightsummary;
                this.template = stopInfo;
                this.renderStop();
                this.render();
                stopDetailsFactory.create(Odigeo._.extend({el: this.$el.find('.stop_details')}, {options: this.getStopDetailsOptions()}));
            });
    },
    getStopDetailsOptions() {
        const messageAndOptions = {
            message: this.stopType.text ?
                `<span>${this.keys[this.stopType.text]}</span>&nbsp;<span>${this.previousSection.arrivalLocation.city}</span>` : '',
            duration: `<span>${this.keys.stopDuration}:</span>&nbsp;<span><b>${this.getStopDuration()}</b></span>`,
            size: '-m',
            stopType: this.stopType,
        };
        const commonOptions = this.getCommonOptions();
        const options = Odigeo._.extend({}, messageAndOptions, commonOptions);
        return options;
    },

    getCommonOptions() {
        const {isHub, hubInsurance} = this.options;
        const {
            stationChange,
            trainChange,
            airportChange,
            airlineChange,
            terminalChange,
            missedConnection,
            visaRequirements,
            selfTransferToAirport,
            selfTransferToTrainStation,
            vinMessageStopInfoTitle,
            vinMessageStopInfo,
        } = this.keys;
        const {section, previousSection} = this;
        return {
            flight: this.isFlight(),
            section,
            previousSection,
            keys: {
                stationChange,
                trainChange,
                airportChange,
                airlineChange,
                terminalChange,
                missedConnection,
                visaRequirements,
                selfTransferToAirport,
                selfTransferToTrainStation,
                vinMessageStopInfo,
                vinMessageStopInfoTitle,
            },
            isHub,
            hubInsurance,
            hubKeys: this.keys,
            alignTitleMargin: this.options.alignWithTitle ? 'od-section-stop-space' : '',
            showChangeOfCarrier: (stopInfoUtils.hasChangeOfFlightCarrier(this.previousSection, this.section)
                || stopInfoUtils.hasChangeOfTrainCarrier(this.previousSection, this.section))
                && !this.isChangeOfCarrierOnly,
            isTravelRestrictionMessage: stopInfoUtils.hasChangeOfCountry(this.previousSection, this.section),
        };
    },

    renderStop() {
        this.prepareKeys();
        this.templateData = {
            wrapperClass: this.options.isVertical ?
                `od-collapsible-stop-vertical ${Odigeo.AB.isNewTripDetails ? 'od-collapsible-stop-vertical-v3' : ''}` : '',
            stopDuration: this.getStopDuration(),
            flight: this.isFlight(),
            keys: this.keys,
            stopType: this.stopType,
        };
    },

    renderHub() {
        new StopInfoHubView({
            el: this.$el.find(this.selectors.stopInfoHub),
            hubInsurance: this.options.hubInsurance,
            keys: this.keys,
            model: this.model,
        });
    },

    render() {
        this.$el.html(this.template(this.templateData));
    },

    getStopDuration() {
        return Odigeo.Utils.convertMinutesToPattern(this.section.stopDuration, this.keys.durationShortPattern) || this.section.stopDuration;
    },

    isTrain() {
        return this.previousSection.aircraft === TRAIN || this.section.aircraft === TRAIN;
    },

    isFlight() {
        return this.previousSection.flight && this.section.flight && !this.isTrain();
    },

    prepareKeys() {
        this.keys.missedConnection = Odigeo.Utils.replaceCmsKeyArgs(this.keys.missedConnection, this.previousSection.carrier.name);
        this.keys.vinMessageStopInfo = Odigeo.Utils.replaceCmsKeyArgs(this.keys.vinMessageStopInfo, this.section.departureLocation.country);
    },

    getStopType() {
        if (stopInfoUtils.isStopBetweenFlights(this.previousSection, this.section)) {
            return this.getFlightStopType();
        } else if (stopInfoUtils.isStopBetweenFlights(this.previousSection, this.section)) {
            return this.getTrainStopType();
        }
        return this.getMixedStopType();
    },

    getFlightStopType() {
        if (stopInfoUtils.hasChangeOfAirport(this.previousSection, this.section)) {
            return stopInfoMap.CHANGE_OF_AIRPORT;
        } else if (stopInfoUtils.hasChangeOfTerminal(this.previousSection, this.section)) {
            return stopInfoMap.CHANGE_OF_TERMINAL;
        } else if (stopInfoUtils.hasChangeOfFlightCarrier(this.previousSection, this.section)) {
            this.isChangeOfCarrierOnly = true;
            return stopInfoMap.CHANGE_OF_FLIGHT_CARRIER;
        }
        return stopInfoMap.DEFAULT;
    },

    getTrainStopType() {
        if (stopInfoUtils.hasChangeOfTrainStation(this.previousSection, this.section)) {
            return stopInfoMap.CHANGE_OF_TRAIN_STATION;
        } else if (stopInfoUtils.hasChangeOfTrainCarrier(this.previousSection, this.section)) {
            this.isChangeOfCarrierOnly = true;
            return stopInfoMap.CHANGE_OF_TRAIN_CARRIER;
        }
        return stopInfoMap.DEFAULT;
    },

    getMixedStopType() {
        if (stopInfoUtils.hasChangeToFlight(this.previousSection, this.section)) {
            return stopInfoMap.CHANGE_TO_FLIGHT;
        }
        return stopInfoMap.CHANGE_TO_TRAIN;
    },
});
